<div class="px-3 h-85vh scroll-custom container-card">
  <h5 class="p-15 txt-bg-blu">Scelta Rappresentazione</h5>
  <div class="">
    <nav
      ngbNav
      #navSceltaRapp="ngbNav"
      class="nav-tabs"
      [destroyOnHide]="false"
    >
      <ng-container
        ngbNavItem
        *ngFor="let tab of tabVisibili; let tab_i = index"
      >
        <a ngbNavLink>{{ tab.tab_name }}</a>
        <ng-template ngbNavContent>
          <div class="tabContent px-3">
            <p class="font-weight-bold" [innerHtml]="tab.title"></p>
            <div [formGroup]="forms[tab_i]" ng-scrollbars>
              <div *ngFor="let content of tab.content">
                <div *ngIf="content.type == 'radio'">
                  <span *ngIf="content.title.length > 0"><br /></span>
                  <span
                    class="font-weight-bold"
                    [innerHtml]="content.title"
                  ></span>
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="vuoto"
                      value="null"
                      [formControlName]="content.group_name"
                      mdbInput
                    />
                    <label class="custom-control-label" for="vuoto"
                      >Vuoto</label
                    >
                    <div *ngFor="let value of content.values; let i = index">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="{{ value }}"
                        [value]="value"
                        [formControlName]="content.group_name"
                        mdbInput
                        [attr.disabled]="
                          forms[tab_i].controls[content.group_name].disabled
                            ? ''
                            : null
                        "
                        [checked]="content.checked == value"
                        #radiobtn
                      />
                      <label class="custom-control-label" for="{{ value }}">{{
                        content.labels[i]
                      }}</label>

                      <div style="display: inline-flex; float: right">
                        <fa-icon
                          class="btnOpacity txt-bg-blu"
                          [icon]="faMinus"
                          *ngIf="radiobtn.checked"
                          ngbTooltip="Diminuisci opacità"
                          (click)="changeLayerOpacity(value, -0.1)"
                        ></fa-icon>
                        <fa-icon
                          class="btnOpacity txt-bg-blu"
                          [icon]="faPlus"
                          *ngIf="radiobtn.checked"
                          ngbTooltip="Aumenta opacità"
                          (click)="changeLayerOpacity(value, 0.1)"
                        ></fa-icon>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="content.type == 'checkbox'">
                  <span *ngIf="content.title.length > 0"><br /></span>
                  <span
                    class="font-weight-bold"
                    [innerHtml]="content.title"
                  ></span>
                  <div *ngFor="let value of content.values; let i = index">
                    <input
                      type="checkbox"
                      id="{{ value }}"
                      [formControl]="
                        forms[tab_i]['controls'][content.group_name][
                          'controls'
                        ][i]
                      "
                      [attr.disabled]="
                        forms[tab_i].controls[content.group_name].disabled
                          ? ''
                          : null
                      "
                      #checkBox
                    />
                    <!--label class="form-check-label check-label" for="{{value}}">{{content.labels[i]}}</label-->

                    <div
                      style="
                        display: inline;
                        width: 400px;
                        word-break: break-word;
                        vertical-align: text-top;
                      "
                    >
                      <label
                        class="form-check-label check-label"
                        for="{{ value }}"
                        >{{ content.labels[i] }}</label
                      >

                      <div style="display: inline-flex; float: right">
                        <fa-icon
                          class="btnOpacity txt-bg-blu"
                          [icon]="faMinus"
                          ngbTooltip="Diminuisci opacità"
                          (click)="changeLayerOpacity(value, -0.1)"
                        ></fa-icon>
                        <fa-icon
                          class="btnOpacity txt-bg-blu"
                          [icon]="faPlus"
                          ngbTooltip="Aumenta opacità"
                          (click)="changeLayerOpacity(value, 0.1)"
                        ></fa-icon>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="content.type == 'select'">
                  <span *ngIf="content.title.length > 0"><br /></span>
                  <span
                    class="font-weight-bold"
                    [innerHtml]="content.title"
                  ></span>

                  <div style="display: inline-flex; float: right">
                    <fa-icon
                      class="btnOpacity txt-bg-blu"
                      [icon]="faMinus"
                      ngbTooltip="Diminuisci opacità"
                      (click)="changeLayerOpacity(selectedLayer.value, -0.1)"
                    ></fa-icon>
                    <fa-icon
                      class="btnOpacity txt-bg-blu"
                      [icon]="faPlus"
                      ngbTooltip="Aumenta opacità"
                      (click)="changeLayerOpacity(selectedLayer.value, 0.1)"
                    ></fa-icon>
                  </div>

                  <select
                    class="browser-default custom-select"
                    [attr.disabled]="
                      forms[tab_i].controls[content.group_name].disabled
                        ? ''
                        : null
                    "
                    [formControlName]="content.group_name"
                    #selectedLayer
                  >
                    <option value="null"></option>
                    <option
                      *ngFor="let value of content.values; let i = index"
                      [value]="value"
                      [selected]="content.checked == value"
                    >
                      {{ content.labels[i] }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="dropdown-divider"></div>

            <button
              class="btn bg-blu txt-white"
              ngbTooltip="Conferma"
              (click)="confirm()"
            >
              Conferma
            </button>
          </div>
        </ng-template>
      </ng-container>
    </nav>

    <div [ngbNavOutlet]="navSceltaRapp" class="mt-2"></div>
  </div>
</div>
